// TODO: palette used not correctly

import { Theme } from '@mui/material/styles'
const formControlHeight = '48px'

const overrides = (theme: Theme) => ({
  MuiDivider: {
    styleOverrides: {
      root: {
        height: '2px',
      },
    },
  },
  MuiTypography: {
    styleOverrides: {
      h1: {
        marginLeft: '-4px',
        lineHeight: '63px',
        color: '#4F5A65',
        marginBottom: '41px',
        fontSize: '57px !important',
        [theme.breakpoints.between(600, 1279)]: {
          fontSize: '43px !important',
          fontWeight: 400,
        },
        [theme.breakpoints.between(0, 600)]: {
          fontSize: '43px !important',
          fontWeight: 400,
          textAlign: 'center',
          lineHeight: '47px',
        },
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        margin: theme.spacing(2, 0, 3),
        '& a': {
          color: `${theme.palette.secondary.main} !important`,
        },
      },
      standardError: {
        backgroundColor: '#F0B5BD',
      },
      standardSuccess: {
        backgroundColor: '#DEF1D9',
      },
      icon: {
        marginRight: theme.spacing(2),
        color: `${theme.palette.secondary.main} !important`,
      },
    },
  },
  MuiAlertTitle: {
    styleOverrides: {
      root: {
        marginBottom: 0,
        fontWeight: 700,
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        marginBottom: theme.spacing(3),
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        margin: theme.spacing(1, 0),
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          color: theme.palette.secondary.main,
          backgroundColor: theme.palette.grey[200],
        },
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        height: formControlHeight,
      },
      input: {
        paddingTop: theme.spacing(1.8125),
        paddingBottom: theme.spacing(1.8125),
        fontSize: '18px',
        lineHeight: '24px',
        color: '#4F5A65',
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      contained: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
        fontSize: '0.85rem',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        height: formControlHeight,
        boxShadow: 'none !important',
        '& .MuiButton-label': {
          textTransform: 'none',
        },
      },
    },
  },
})

export default overrides
